import type { FC } from "react"
import { useSearchParams } from "react-router-dom"

import { useLazyQuery } from "@apollo/client"

import styles from "./SalonSelectAndHome.module.scss"

import SalonSelect from "@/lib/components/SalonSelect/SalonSelect"
import { useSalonListForStoreManagement } from "@/lib/graphql/me"
import { useSwitchSalonForStoreManagement } from "@/lib/graphql/useSwitchSalon"
import { DEFAULT_TAB } from "@/souhl_admin/components/features/companies/CompanyTabBar/CompanyTabBar"
import { graphql } from "@/souhl_admin/gql/__generated__"

const companyBySalonIdQuery = graphql(/* GraphQL */ `
	query CompanyBySalonIdForSalonSelect($param: CompanyBySalonIdParam!) {
		companyBySalonId(param: $param) {
			company {
				id
			}
		}
	}
`)

type SalonSelectAndHomeProps = {
	companyId: string
}

const SalonSelectAndHome: FC<SalonSelectAndHomeProps> = ({ companyId }) => {
	const { salons, loading: meLoading } = useSalonListForStoreManagement()
	const switchSalon = useSwitchSalonForStoreManagement()

	const [searchParams] = useSearchParams()
	const currentTab = searchParams.get("tab") || DEFAULT_TAB

	const [fetchCompanyBySalon] = useLazyQuery(companyBySalonIdQuery)

	const handleSalonChange = (salonId: number) => {
		// 1. サロンの所属会社を特定
		fetchCompanyBySalon({
			variables: { param: { salon_id: salonId } },
		})
			.then(async ({ data }) => {
				const newCompanyId = data?.companyBySalonId?.company?.id
				const targetUrl = newCompanyId
					? `/souhl_admin/companies/${newCompanyId}?tab=${currentTab}`
					: "/souhl_admin"

				// 2. SalonContext をサーバーサイドで同期
				return await switchSalon(salonId)
					.then(() => targetUrl)
					.catch((error) => {
						console.error("店舗の切り替えに失敗しました", error)
						return targetUrl
					})
			})
			.then((targetUrl) => {
				// 3. ページリロード付きで遷移（全データ再取得）
				window.location.href = targetUrl
			})
			.catch((error) => {
				console.error(`Company not found for salon ${salonId}`, error)
				window.location.href = "/souhl_admin"
			})
	}

	if (meLoading) return null

	return (
		<div className={styles.salonSelectAndHome}>
			<SalonSelect salons={salons} onChangeSalon={handleSalonChange} />
			<button
				className={styles.homeButton}
				onClick={() => {
					window.location.href = "/"
				}}
			>
				Home画面へ移動
			</button>
		</div>
	)
}

export default SalonSelectAndHome
